import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import FormGroup from '../../FormGroup';
import ConsumerRootContentSearch from './ConsumerRootContentSearch';

const propTypes = {
  values: PropTypes.shape({
    hierarchy_item_id: PropTypes.string,
    description: PropTypes.string,
  }),
  handleChange: PropTypes.func,
};

const OnboardingForm = ({ values, handleChange }) => {
  return (
    <Fragment>
      <FormGroup
        id="email_address"
        label="Email Address"
        onChange={handleChange}
        placeholder="Enter your email address here"
        value={values.email_address}
        required
      />
      <ConsumerRootContentSearch values={values} handleChange={handleChange} />
      <FormGroup
        id="description"
        label={
          <p className="text-light text-xs text-bold text-uppercase mb-0">
            Description <span className="text-primary">(Optional)</span>
          </p>
        }
        type="textarea"
        onChange={handleChange}
        value={values.description}
      />
    </Fragment>
  );
};

OnboardingForm.propTypes = propTypes;

export default OnboardingForm;
